import { render, staticRenderFns } from "./TotemsTable.vue?vue&type=template&id=6bbdd6a8"
import script from "./TotemsTable.vue?vue&type=script&lang=js"
export * from "./TotemsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports